export default {
  labels: {
    selectOne: "Selecciona una opción",
    selectAll: "Selecciona todas las que correspondan",
    typeResponse: "Escribe tu respuesta en el cuadro de texto a continuación.",
    recordResponse: "Graba una respuesta para contestar la pregunta.",
    enterNumeric: "Ingresa una respuesta numérica en el campo a continuación.",
    rateResponseScale: "Evalúa tu respuesta en la escala proporcionada.",
    sliderMinimum: 'Valor mínimo: {value}',
    sliderMaximum: 'Valor máximo: {value}',
    selectOneOptionRow: "Selecciona una opción en cada fila.",
    selectAllOptionsRow: "Selecciona todas las opciones que correspondan para cada fila.",
    dragAndDropResponse: "Arrastra y suelta las opciones para ordenarlas según tu preferencia.",
    rankOrderDesktopInstruction: 'Arrastra y suelta los elementos para ordenarlos, o usa el botón + para añadir un elemento. Usa los botones de flecha para reordenar o el botón eliminar para quitar un elemento.',
    alert: "Alerta",
    error: 'Por favor, introduce un número entre {min} y {max}.',
    cameras: 'Cámaras',
    microphones: 'Micrófonos',
    recording: 'Grabación',
    noDevicesFound: 'No se encontraron dispositivos',
    camera: 'Cámara',
    microphone: 'Micrófono',
    stopRecording: 'Detener grabación',
    startRecording: 'Iniciar grabación',
    disableCamera: 'Desactivar cámara',
    enableCamera: 'Activar cámara',
    disableMicrophone: 'Desactivar micrófono',
    enableMicrophone: 'Activar micrófono',
    settings: 'Configuración',
    recordingProgress: 'Progreso de la grabación',
    playbackProgress: 'Progreso de reproducción',
    play: 'Reproducir',
    pause: 'Pausar',
    stop: 'Detener',
    record: 'Grabar',
    recordAgain: 'Volver a grabar',
    retry: 'Volver a intentar',
    done: 'Listo',
    minRecordTime: 'Por favor, graba una respuesta durante {min} segundos.',
    enlargeImage: 'Ampliar imagen',
    enlargedImage: 'Imagen ampliada',
    close: 'Cerrar',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    resetZoom: 'Restablecer zoom',
    zoomLevel: 'Zoom {percentage}%',
    imagePosition: '{current} de {total}',
    previousImage: 'Imagen anterior',
    nextImage: 'Imagen siguiente',
    imageLoading: 'Cargando imagen',
    imageLoadFailed: 'No se ha podido cargar la imagen',
  },
  noSelection: 'Sin selección',
  actions: {
    increase: 'Aumentar',
    decrease: 'Disminuir'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Vista Previa de Encuesta Terminada',
      titleCompleted: 'Vista Previa de Encuesta Completada',
      previewModeWarning: 'Esta página solo es visible en el Modo de Vista Previa y no se mostrará a los encuestados reales.',
      reachedEndPoint: 'Esta encuesta ha llegado a un punto final.',
      reachedEndPointCompleted: 'Esta vista previa ha llegado a un punto final.',
      returnToModify: 'Vuelve a la pregunta anterior para modificar tus respuestas y probar una ruta de encuesta diferente.',
      logic: 'Lógica'
    }
  }
}
